// Import types

// Import components directly
import AdvertiserDisclosureWrapper from '~/app/components/advertiser-disclosure/advertiser-disclosure';
import ArticleHeroWrapper from '~/app/components/article-hero-wrapper/article-hero-wrapper';
import AutoInsuranceMatches from '~/app/components/auto-insurance-matches/base-auto-insurance-matches';
import Awards2024Buttons from '~/app/components/awards-2024-buttons/awards-2024-buttons';
import AwardsBadgeDropdown from '~/app/components/awards-badge-dropdown/awards-badge-dropdown';
import AwardsNavigation from '~/app/components/awards-navigation/awards-navigation';
import BackToTop from '~/app/components/back-to-top/back-to-top';
import BainReferralBannerSC from '~/app/components/bain-referral-banner-sc/bain-referral-banner-sc';
import BorderBanner from '~/app/components/border-banner/border-banner';
import CurrentDate from '~/app/components/current-date/current-date';
import DynamicGrid from '~/app/components/dynamic-grid/dynamic-grid';
import EditorControl from '~/app/components/editor-control/editor-control';
import Filters from '~/app/components/filters/filters';
import FixedFirstColumnTable from '~/app/components/fixed-first-column-table/fixed-first-column-table';
import FlexCards from '~/app/components/flex-cards/flex-cards';
import GlobalNav from '~/app/components/global-nav/global-nav';
import GridForm from '~/app/components/grid-form/grid-form';
import Grid from '~/app/components/grid/grid';
import HorizontalBanner from '~/app/components/horizontal-banner/horizontal-banner';
import InputButton from '~/app/components/input-button/input-button';
import InsuranceProductCardWrapper from '~/app/components/insurance-product-card-wrapper/insurance-product-card-wrapper';
import InsuranceSummaryTableWrapper from '~/app/components/insurance-summary-table-wrapper/insurance-summary-table-wrapper';
import KetoProductCard from '~/app/components/keto-product-card/keto-product-card';
import LottieAnimation from '~/app/components/lottie-animation/lottie-animation';
import MultilevelFilters from '~/app/components/multilevel-filters/multilevel-filters';
import OurValues from '~/app/components/our-values/our-values';
import Page from '~/app/components/page';
import RetirementCalculatorSC from '~/app/components/retirement-calculator-sc/retirement-calculator-sc';
import StickyHeader from '~/app/components/sticky-header/sticky-header';
import ThirdPartyEmbed from '~/app/components/third-party-embed/third-party-embed';
import UniversalAccordion from '~/app/components/universal-accordion/universal-accordion';
import UniversalBulletList from '~/app/components/universal-bullet-list/universal-bullet-list';
import UniversalButton from '~/app/components/universal-button/universal-button';
import UniversalContainer from '~/app/components/universal-container/universal-container';

import {
  ADVERTISERDISCLOSUREWRAPPER,
  ARTICLEHEROWRAPPER,
  AUTOINSURANCEMATCHES,
  AWARDS2024BUTTONS,
  AWARDSBADGEDROPDOWN,
  AWARDSNAVIGATION,
  BACKTOTOP,
  BAINREFERRALBANNERSC,
  BORDERBANNER,
  CURRENTDATE,
  DYNAMICGRID,
  EDITORCONTROL,
  FILTERS,
  FIXEDFIRSTCOLUMNTABLE,
  FLEXCARDS,
  GLOBALNAV,
  GRID,
  GRIDFORM,
  HORIZONTALBANNER,
  INPUTBUTTON,
  INSURANCEPRODUCTCARDWRAPPER,
  INSURANCESUMMARYTABLEWRAPPER,
  KETOPRODUCTCARD,
  LOTTIEANIMATION,
  MULTILEVELFILTERS,
  OURVALUES,
  PAGE,
  RETIREMENTCALCULATORSC,
  STICKYHEADER,
  THIRDPARTYEMBED,
  UNIVERSALACCORDION,
  UNIVERSALBULLETLIST,
  UNIVERSALBUTTON,
  UNIVERSALCONTAINER,
} from './lpc-types';

// Register custom components to be rendered in LPC
export const lpcComponents = {
  [ADVERTISERDISCLOSUREWRAPPER]: () => AdvertiserDisclosureWrapper,
  [ARTICLEHEROWRAPPER]: () => ArticleHeroWrapper,
  [AUTOINSURANCEMATCHES]: () => AutoInsuranceMatches,
  [AWARDS2024BUTTONS]: () => Awards2024Buttons,
  [AWARDSBADGEDROPDOWN]: () => AwardsBadgeDropdown,
  [AWARDSNAVIGATION]: () => AwardsNavigation,
  [BAINREFERRALBANNERSC]: () => BainReferralBannerSC,
  [BACKTOTOP]: () => BackToTop,
  [BORDERBANNER]: () => BorderBanner,
  [CURRENTDATE]: () => CurrentDate,
  [EDITORCONTROL]: () => EditorControl,
  [FILTERS]: () => Filters,
  [FIXEDFIRSTCOLUMNTABLE]: () => FixedFirstColumnTable,
  [FLEXCARDS]: () => FlexCards,
  [GLOBALNAV]: () => GlobalNav,
  [GRID]: () => Grid,
  [GRIDFORM]: () => GridForm,
  [HORIZONTALBANNER]: () => HorizontalBanner,
  [INPUTBUTTON]: () => InputButton,
  [INSURANCESUMMARYTABLEWRAPPER]: () => InsuranceSummaryTableWrapper,
  [INSURANCEPRODUCTCARDWRAPPER]: () => InsuranceProductCardWrapper,
  [KETOPRODUCTCARD]: () => KetoProductCard,
  [LOTTIEANIMATION]: () => LottieAnimation,
  [MULTILEVELFILTERS]: () => MultilevelFilters,
  [PAGE]: () => Page,
  [RETIREMENTCALCULATORSC]: () => RetirementCalculatorSC,
  [DYNAMICGRID]: () => DynamicGrid,
  [STICKYHEADER]: () => StickyHeader,
  [THIRDPARTYEMBED]: () => ThirdPartyEmbed,
  [OURVALUES]: () => OurValues,
  [UNIVERSALACCORDION]: () => UniversalAccordion,
  [UNIVERSALBULLETLIST]: () => UniversalBulletList,
  [UNIVERSALBUTTON]: () => UniversalButton,
  [UNIVERSALCONTAINER]: () => UniversalContainer,
};
